import { createAsyncThunk } from '@reduxjs/toolkit'
import request, { getAxiosRequestConfig } from 'utils/request.ts'
import { Methods } from 'types/request.ts'
import { FeedbackEntry, FeedbackWidgetAPI, FeedbackWidget } from 'store/feedbackWidget/types.ts'

export const getWidgets = createAsyncThunk('feedbackWidget/getWidgets', async (_, thunkAPI) => {
  try {
    const widgets = await request(getAxiosRequestConfig(Methods.GET, '/feedback-widgets'))
    const entries = await request(getAxiosRequestConfig(Methods.GET, '/feedback-widgets/entries'))

    if (widgets.success && entries.success) {
      const mappedWidgets = widgets.data.data.reduce((prev: FeedbackWidget[], curr: FeedbackWidgetAPI) => {
        const entriesByWidget = entries.data.data?.filter((entry: FeedbackEntry) => entry.feedbackWidgetId === curr._id) ?? []
        const average = entriesByWidget.length
          ? entriesByWidget.reduce((prev: number, curr: FeedbackEntry) => prev + (curr.score || 0), 0) / entriesByWidget.length
          : 0

        prev.push({ ...curr, average: average, entries: entriesByWidget })
        return prev
      }, [])

      return { widgets: mappedWidgets }
    }

    return thunkAPI.rejectWithValue((widgets.message || entries.message) ?? 'getWidgets')
  } catch (err) {
    const { message } = err as Error
    return thunkAPI.rejectWithValue(message)
  }
})
